export const companyList = [
  {
    name: 'Capgemini',
    designation: 'Consultant',
    period: 'May 2025 - Present',
    points: [
      'Working on banking project, created internal app from scratch for stakeholders using Lit framework, Typescript, Jest',
      'Integrated GraphQL and Rest APIs',
      'Worked with internal design system',
      'Helped team with code refactoring for cleaner code and optimized performance'
    ],
  },
  {
    name: 'Beas Consultancy',
    designation: 'Sr.Software Engineer',
    period: 'Feb 2025 - May 2025',
    points: [
      'Created modules using ReactJS, Context API, and Material-UI',
      'Collaborated with cross-functional teams to design and implement scalable React components',
    ],
  },
  {
    name: 'Venturit',
    designation: 'Application Developer',
    period: 'Dec 2021 - Feb 2024',
    points: [
      'Created modules using ReactJS, Redux, Typescript, and Material-UI',
      'Revitalized mobile app by leveraging React Native, resulting in a 25% improvement in user experience',
      'Built Rest APIs using Node JS, and Express JS and managed data storage using Mongo DB',
      'Integrated third party APIs to the Frontend',
    ],
  },
  {
    name: 'The Math Company',
    designation: 'Senior Associate',
    period: 'Nov 2020 - June 2021',
    points: [
      'Developing new user-facing features using ReactJS',
      'Collaborating with designers to ensure designs were efficient and technically sound',
      'Creating modular, responsive templates using modern CSS techniques and javascript libraries',
      'Optimizing visual and coding elements to improve loading speed and performance',
    ],
  },
  {
    name: 'Synchrony Financial',
    designation: 'Senior Analyst',
    period: 'March 2020 - Nov 2020',
    points: [
      'Creating new features and functionality on the existing website',
      'Teamed with backend developers and designers to meet project goals',
      'Worked on debugging code to solve functionality issues in the frontend',
      'Ensuring proper documentation for changes made',
    ],
  },
  {
    name: 'Cashify',
    designation: 'Assistant Manager-Operations',
    period: 'Feb 2018 - Jan 2019',
    points: [
      'Building strategies and structuring city operations',
      'Ensuring smooth logistics operations throughout the city',
      'Keeping company revenue high by procuring excellent products',
      'Keeping check on frauds through best practices',
    ],
  },
  {
    name: 'Paytm',
    designation: 'Senior Associate-Operations',
    period: 'Sep 2014 - Feb 2018',
    points: [
      'Managed State level field operations',
      'End-to-End Agency Management',
      'Participated with management in creating optimal process & execution flow',
      'Effective participation and contribution to roll out of new Process and systems',
    ],
  },
];

export const createCompany = ({ name, designation = '', period = '', points = [] }) => ({
  name,
  designation,
  period,
  points,
});

export const prependCompany = (list, company) => [company, ...list];
